/** COCYPHER IT SOLUTIONS PRIVATE LIMITED
 * * Project Name : ecoPresence
 * * Layer Name : UI Design
 * * Section : Foot          background: isAudioBook
            ? darkMode
              ? `linear-gradient(135deg, ${theme.palette.secondary.main}80 0%, ${theme.palette.secondary.main}65 50%, ${theme.palette.secondary.main}50 100%)`
              : `linear-gradient(135deg, ${theme.palette.secondary.main}85 0%, ${theme.palette.secondary.main}70 50%, ${theme.palette.secondary.main}55 100%)`
            : darkMode
            ? "linear-gradient(135deg, rgba(8, 8, 8, 0.7) 0%, rgba(15, 15, 15, 0.6) 50%, rgba(8, 8, 8, 0.5) 100%)"
            : "linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(250, 250, 250, 0.4) 50%, rgba(255, 255, 255, 0.3) 100%)",
          backdropFilter: !isAudioBook ? "blur(20px) saturate(1.8)" : "none",Parent : Home
 * Description : design homepage primary slider with images/videos
 * Author: Suryakanta sahu
 * Date Created: 20-Mar-2022
 *
 *
 *
 *
 *
 */
/** --------- Primary Import Declaration --------------- */
import React, { useContext, useEffect, useState } from "react";
import { css, jsx } from "@emotion/react";
/** --------- MUI Components & APIs -----------*/
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";

import { ThemeContext } from "context/ThemeContext";
import { AuthContext } from "context/Authentication";
import { useNavigate } from "react-router-dom";
/** ---------- Common Styles ---------------- */
import commonStyles from "../../assets/styles/commonstyles/commonStyles";
/** ----------- Image Files --------------- */
/** ----- This is using for Icon section ------ */
import FacebookTwoToneIcon from "@mui/icons-material/FacebookTwoTone";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import { postRecord } from "services/services";
import CompactFooter from "./CompactFooter.jsx";
import GradientBackground from "./GradientBackground.jsx";

const API_GetAllPages = "pages/getall";
const API_GetAllCategories = "productcategories/getall";
const API_GetAllPolicies = "policy_documents/getall";

export default function Footer() {
  const [pages, setPages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [policies, setPolicies] = useState([]);
  const themeMode = useContext(ThemeContext);
  const darkMode = themeMode.state.darkMode;
  const context = useContext(AuthContext);
  const companyInfo = context.state.companyInfo;
  const navigate = useNavigate();
  const theme = useTheme();

  // Check if it's an AudioBook/Digital Product
  const isAudioBook =
    context.state.companyInfo?.Product_Service_Type === "Product - Digital";

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const pagesResponse = await postRecord(API_GetAllPages, {
          page: 1,
          limit: 100,
        });
        if (pagesResponse.status === 200 && pagesResponse.data && isMounted) {
          const filteredPages = pagesResponse.data
            .filter(
              (page) =>
                page.Is_Internal === "0" &&
                page.Page_Name !== "School Zones" &&
                page.Page_Name !== "My Students"
            )
            .sort((a, b) => {
              // Sort by Page_Order (ascending), handle null/undefined values
              const orderA = a.Page_Order || 0;
              const orderB = b.Page_Order || 0;
              return orderA - orderB;
            });
          setPages(filteredPages);
        }

        const categoriesResponse = await postRecord(API_GetAllCategories, {});
        if (
          categoriesResponse.status === 200 &&
          categoriesResponse.data &&
          isMounted
        ) {
          setCategories(
            categoriesResponse.data.filter(
              (category) =>
                category.On_Homepage === "1" &&
                (!category.Category_Tags ||
                  !category.Category_Tags.includes("School Menu"))
            )
          );
        }

        const policiesResponse = await postRecord(API_GetAllPolicies, {});
        if (
          policiesResponse.status === 200 &&
          policiesResponse.data &&
          isMounted
        ) {
          setPolicies(policiesResponse.data);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching footer data:", error);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <Box
        sx={{
          padding: { xs: "30px 20px", md: "40px 20px" },
          marginTop: "auto",
          background: isAudioBook
            ? darkMode
              ? `linear-gradient(135deg, ${theme.palette.secondary.main}80 0%, ${theme.palette.secondary.main}65 50%, ${theme.palette.secondary.main}50 100%)`
              : `linear-gradient(135deg, ${theme.palette.secondary.main}85 0%, ${theme.palette.secondary.main}70 50%, ${theme.palette.secondary.main}55 100%)`
            : darkMode
            ? "linear-gradient(135deg, rgba(10, 10, 10, 0.8) 0%, rgba(20, 20, 20, 0.7) 50%, rgba(15, 15, 15, 0.6) 100%)"
            : "linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(250, 250, 250, 0.4) 50%, rgba(255, 255, 255, 0.3) 100%)",
          backdropFilter: !isAudioBook ? "blur(15px) saturate(1.5)" : "none",
          border: !isAudioBook
            ? darkMode
              ? "1px solid rgba(255, 255, 255, 0.1)"
              : "1px solid rgba(255, 255, 255, 0.3)"
            : "none",
          boxShadow: !isAudioBook
            ? darkMode
              ? "0 8px 32px rgba(0, 0, 0, 0.3)"
              : "0 8px 32px rgba(0, 0, 0, 0.1)"
            : "none",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Gradient Wave Background Animation - Only for AudioBook/Digital Products */}
        <GradientBackground isVisible={isAudioBook} darkMode={darkMode} />

        {/* Content Layer */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Container maxWidth="xl">
            <Grid
              container
              spacing={3}
              sx={{
                justifyContent: "center",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              {/* Useful Links Section */}
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "15px",
                    fontWeight: 600,
                    color: "inherit",
                  }}
                >
                  Useful Links
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box>
                  {pages.map((page) => (
                    <Button
                      variant="text"
                      color="inherit"
                      key={page.Page_Id}
                      onClick={() => navigate(page.Page_Navigation_URL)}
                      sx={{
                        display: "block",
                        textTransform: "none",
                        marginBottom: "8px",
                        cursor: "pointer",
                        textAlign: "left",
                        justifyContent: "flex-start",
                        width: "100%",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: darkMode
                            ? "rgba(255, 255, 255, 0.05)"
                            : "rgba(0, 0, 0, 0.05)",
                          transform: "translateX(5px)",
                        },
                      }}
                    >
                      {page.Page_Name}
                    </Button>
                  ))}
                </Box>
              </Grid>

              {/* Top Categories Section */}
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "15px",
                    fontWeight: 600,
                    color: "inherit",
                  }}
                >
                  Top Categories
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box>
                  {categories.map((category) => (
                    <Button
                      variant="text"
                      color="inherit"
                      key={category.Category_Id}
                      onClick={() => {
                        const formattedCategoryName =
                          category.Category_Name.toLowerCase().replace(
                            / /g,
                            "-"
                          );
                        const baseRoute =
                          category.Category_Type === "Service"
                            ? "/ServiceList"
                            : "/ProductList";
                        navigate(`${baseRoute}/${formattedCategoryName}`);
                      }}
                      sx={{
                        display: "block",
                        textTransform: "none",
                        marginBottom: "8px",
                        cursor: "pointer",
                        textAlign: "left",
                        justifyContent: "flex-start",
                        width: "100%",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: darkMode
                            ? "rgba(255, 255, 255, 0.05)"
                            : "rgba(0, 0, 0, 0.05)",
                          transform: "translateX(5px)",
                        },
                      }}
                    >
                      {category.Category_Name}
                    </Button>
                  ))}
                </Box>
              </Grid>

              {/* Policies Section */}
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "15px",
                    fontWeight: 600,
                    color: "inherit",
                  }}
                >
                  Policies
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box>
                  {policies.map((policy) => (
                    <Button
                      variant="text"
                      color="inherit"
                      key={policy.PolicyDocument_Id}
                      onClick={() =>
                        navigate(
                          `/Policy/${policy.Title.toLowerCase().replace(
                            / /g,
                            "-"
                          )}`
                        )
                      }
                      sx={{
                        display: "block",
                        textTransform: "none",
                        marginBottom: "8px",
                        cursor: "pointer",
                        textAlign: "left",
                        justifyContent: "flex-start",
                        width: "100%",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: darkMode
                            ? "rgba(255, 255, 255, 0.05)"
                            : "rgba(0, 0, 0, 0.05)",
                          transform: "translateX(5px)",
                        },
                      }}
                    >
                      {policy.Title}
                    </Button>
                  ))}
                </Box>
              </Grid>

              {/* Contact Section */}
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "15px",
                    fontWeight: 600,
                    color: "inherit",
                  }}
                >
                  Contact
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      mb: 2,
                      p: 1,
                      borderRadius: 1,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: darkMode
                          ? "rgba(255, 255, 255, 0.05)"
                          : "rgba(0, 0, 0, 0.05)",
                      },
                    }}
                  >
                    <EmailIcon sx={{ mr: 1 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {companyInfo?.Primary_Email}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      mb: 2,
                      p: 1,
                      borderRadius: 1,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: darkMode
                          ? "rgba(255, 255, 255, 0.05)"
                          : "rgba(0, 0, 0, 0.05)",
                      },
                    }}
                  >
                    <PhoneIcon sx={{ mr: 1 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {companyInfo?.Primary_Phone}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "8px",
                      mt: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Tooltip title="Facebook">
                      <IconButton
                        href={companyInfo?.Facebook_Link}
                        target="_blank"
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(0, 0, 0, 0.1)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <FacebookTwoToneIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Twitter">
                      <IconButton
                        href={companyInfo?.Twitter_Link}
                        target="_blank"
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(0, 0, 0, 0.1)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <TwitterIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="LinkedIn">
                      <IconButton
                        href={companyInfo?.Linkedin_Link}
                        target="_blank"
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(0, 0, 0, 0.1)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <LinkedInIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Instagram">
                      <IconButton
                        href={companyInfo?.Custom_Link_01}
                        target="_blank"
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(0, 0, 0, 0.1)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <InstagramIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Youtube">
                      <IconButton
                        href={companyInfo?.Youtube_Link}
                        target="_blank"
                        sx={{
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: darkMode
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(0, 0, 0, 0.1)",
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        <YouTubeIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
      <CompactFooter />
    </React.Fragment>
  );
}
